import React from 'react';
import PanettoneQuotaSedes from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/QuotaSedes/List.js';

export default function () {
  return <PanettoneQuotaSedes />;
}
